import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, useIafCopy } from "@inteacc/ui";
const defaults = {
    loading: {
        title: "Loading",
        message: "The requested information is loading.",
    },
    empty: {
        title: "Nothing here yet",
        message: "No authorized information is available.",
    },
    error: {
        title: "Unable to load",
        message: "The request could not be completed.",
    },
    "access-denied": {
        title: "Access denied",
        message: "You do not have permission to view this content.",
    },
    offline: {
        title: "You are offline",
        message: "Reconnect to continue.",
    },
    "not-found": {
        title: "Not found",
        message: "The requested page or record does not exist.",
    },
};
export const ApplicationState = ({ actionLabel, children, correlationId, kind, message, onAction, title, }) => {
    const t = useIafCopy();
    const content = defaults[kind];
    const isLoading = kind === "loading";
    const isAlert = kind === "error" || kind === "access-denied" || kind === "offline";
    return (_jsxs("section", { "aria-busy": isLoading || undefined, "aria-live": isLoading ? "polite" : undefined, className: `iaf-experience-state iaf-experience-state--${kind}`, role: isAlert ? "alert" : "status", children: [_jsx("h2", { children: t(title ?? content.title) }), _jsx("p", { children: t(message ?? content.message) }), children, correlationId ? _jsxs("small", { children: [t("Reference"), ": ", correlationId] }) : null, actionLabel && onAction ? (_jsx(Button, { onClick: onAction, tone: "neutral", children: t(actionLabel) })) : null] }));
};
//# sourceMappingURL=states.js.map